import { gql, useQuery } from '@apollo/client'
import { Table, Progress, Button, Alert } from 'reactstrap'
import DatetimeRenderer from '../../Material/DatetimeRenderer'
import './RenderUberAccidents.css'


const AllUberAccidentsQuery = gql`query AllUberAccidents($vin: String!, $incidentDate: Date, $limit: Int, $dateAddedCursor: DateTime){
    allUberAccidents(vin: $vin, incidentDate: $incidentDate, limit: $limit, dateAddedCursor: $dateAddedCursor){
        dateAdded
        dateModified
        vehicleSolutions
        uberNumber
        dateReported
        driverName
        period
        incidentDate
        passengerName
        passengerPhone
        passengerEmail
        driverStatement
        passengerStatement
        thirdPartyVersion
        passengersCount
        injuriesReported
        injuriesDetails
        emsTransport
        policeInvolvement
        policeDepartmentName
        policeReportNumber
        vehicleTowed
        towInfo
        attorneyInvolvement
        attorneyDetails
        additionalDetails
        lossLocation
        hasNextPage
    } 
}`

export default function RenderUberAccidents({ vin, incidentDate }) {

    const { data: allUberAccidentsData, loading: allUberAccidentsLoading, error: allUberAccidentsError, fetchMore: fetchMoreArgyleGigs } = useQuery(AllUberAccidentsQuery, {
        variables: {
            vin: vin,
            incidentDate: incidentDate ? incidentDate : null,
            limit: 10,
        },
        skip: !vin,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    })

    const loadMoreArgyleGigs = () => {
        fetchMoreArgyleGigs({
            variables: {
                dateAddedCursor: allUberAccidentsData?.allUberAccidents[allUberAccidentsData?.allUberAccidents.length - 1].dateAdded,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                return {
                    allUberAccidents: [...previousResult.allUberAccidents, ...fetchMoreResult.allUberAccidents],
                }
            },
        })
    }

    return (
        <div className="uber-accidents-feed">
            {allUberAccidentsError && <Alert color="danger">{allUberAccidentsError.message}</Alert>}
            <div className="uber-accidents-table-container">
                <Table size="sm" className="uber-accidents-table">
                    <thead>
                        <tr>
                            <th>Date Added</th>
                            <th>Uber ID</th>
                            <th>Incident Date</th>
                            <th>Date Reported</th>
                            <th>Driver Name</th>
                            <th>Period</th>
                            <th>Passengers Count</th>
                            <th>Passenger Details</th>
                            <th className="wrap-text">Driver Statement</th>
                            <th className="wrap-text">Passenger Statement</th>
                            <th>Third Party Version</th>
                            <th>Injuries</th>
                            <th>EMS Transport</th>
                            <th>Police Involvement</th>
                            <th>Tow Info</th>
                            <th>Attorney Details</th>
                            <th className="wrap-text">Additional Details</th>
                            <th>Loss Location</th>
                            {/* 
                            <th>Accident Circumstances</th>
                            <th>Claim Submitted</th>
                            <th>Carrier Name</th>
                            <th>Claim Number</th>
                            <th>Origin State</th>
                            <th>Facts of Loss</th>
                            <th>Facts of Loss Translated</th>
                            */}
                        </tr>
                    </thead>
                    <tbody>
                        {allUberAccidentsData?.allUberAccidents?.map((uberAccident, i) => (
                            <tr>
                                <td><DatetimeRenderer datetime={uberAccident.dateAdded} /></td>
                                <td>{uberAccident.uberNumber}</td>
                                <td>{uberAccident.incidentDate}</td>
                                <td>{uberAccident.dateReported}</td>
                                <td>{uberAccident.driverName}</td>
                                <td>{uberAccident.period}</td>
                                <td>{uberAccident.passengersCount !== null ? uberAccident.passengersCount : "--"}</td>
                                <td>
                                    <i className="fa fa-user" />&nbsp;
                                    {uberAccident.passengerName}
                                    <br />
                                    <i className="fa fa-phone" />&nbsp;
                                    {uberAccident.passengerPhone}
                                    <br />
                                    <i className="fa fa-envelope" />&nbsp;
                                    {uberAccident.passengerEmail}
                                </td>
                                <td className="wrap-text">{uberAccident.driverStatement || "--"}</td>
                                <td className="wrap-text">{uberAccident.passengerStatement || "--"}</td>
                                <td>{uberAccident.thirdPartyVersion || "--"}</td>
                                <td>({uberAccident.injuriesReported || "--"}) {uberAccident.injuriesDetails}</td>
                                <td>{uberAccident.emsTransport || "--"}</td>
                                <td>({uberAccident.policeInvolvement || "--"}) {uberAccident.policeDepartmentName} {uberAccident.policeReportNumber ? `#${uberAccident.policeReportNumber}` : ""}</td>
                                <td>({uberAccident.vehicleTowed || "--"}) {uberAccident.towInfo}</td>
                                <td>({uberAccident.attorneyInvolvement || "--"}) {uberAccident.attorneyDetails}</td>
                                <td className="wrap-text">{uberAccident.additionalDetails || "--"}</td>
                                <td>{uberAccident.lossLocation || "--"}</td>
                                {/* 
                                <td>{uberAccident.accidentCircumstances}</td>
                                <td>{uberAccident.claimSubmitted}</td>
                                <td>{uberAccident.carrierName}</td>
                                <td>{uberAccident.claimNumber}</td> 
                                <td>{uberAccident.originState}</td>
                                <td>{uberAccident.factsOfLoss}</td>
                                <td>{uberAccident.factsOfLossTranslated}</td>
                                */}
                            </tr>
                        ))}
                        <tr className="uber-accidents-table__footer">
                            <td colSpan={10} className="text-right">
                                {allUberAccidentsLoading ? <Progress animated value={100} /> :
                                    allUberAccidentsData?.allUberAccidents?.length === 0 ? <p className="uber-accidents-empty">No Uber Accidents Found!</p> : allUberAccidentsData?.allUberAccidents?.filter(record => record.hasNextPage).length > 0 && <Button className='primary' size="sm" onClick={loadMoreArgyleGigs} style={{ cursor: "pointer" }}>Load More</Button>
                                }
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )
}
